// import defaultSettings from '@/settings'
import { websiteInfo } from '@/api/admin'

export default function getPageTitle() {
	return new Promise((resolve,reject) => {
		websiteInfo({}).then(res=>{
			resolve(res);
		})
	})
}
